import script from "./DynamicPageView.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicPageView.vue?vue&type=script&setup=true&lang=js"

import "./DynamicPageView.vue?vue&type=style&index=0&id=b24418f6&scoped=true&lang=css"
import "./DynamicPageView.vue?vue&type=style&index=1&id=b24418f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b24418f6"]])

export default __exports__